export interface AdvisorData {
  slug: string;
  name: string;
  whatsapp: string;
  phone: string;
  wapp: string;
}

export const advisors: Record<string, AdvisorData> = {
  "daniel-ballesteros": {
    slug: "daniel-ballesteros",
    name: "Daniel Ballesteros",
    whatsapp: "573001234567",
    phone: "3170689271",
    wapp: "https://wa.me/573170689271?text=Hola,%20estoy%20interesado(a)%20en%20conocer%20el%20proceso%20de%20financiamiento%20de%20Alianza%20Andina%20Empresarial.%20%20",
  },
  "david-roldan": {
    slug: "david-roldan",
    name: "David Roldán",
    whatsapp: "573002345678",
    phone: "3013995219",
    wapp: "https://wa.me/573013995219?text=Hola,%20estoy%20interesado(a)%20en%20conocer%20el%20proceso%20de%20financiamiento%20de%20Alianza%20Andina%20Empresarial.%20%20",
  },
  "fernando-bonilla": {
    slug: "fernando-bonilla",
    name: "Fernando Bonilla",
    whatsapp: "573003456789",
    phone: "3217399398",
    wapp: "https://wa.link/qwslc8",
  },
  gustavo: {
    slug: "gustavo",
    name: "Gustavo",
    whatsapp: "573004567890",
    phone: "3022338942",
    wapp: "https://wa.me/573022338942?text=Hola,%20estoy%20interesado(a)%20en%20conocer%20el%20proceso%20de%20financiamiento%20de%20Alianza%20Andina%20Empresarial.%20%20",
  },
  "katerine-montoya": {
    slug: "katerine-montoya",
    name: "Katerine Montoya",
    whatsapp: "573005678901",
    phone: "3244547394",
    wapp: "https://wa.me/573244547394?text=Hola,%20estoy%20interesado(a)%20en%20conocer%20el%20proceso%20de%20financiamiento%20de%20Alianza%20Andina%20Empresarial.",
  },
  "miguel-andrade": {
    slug: "miguel-andrade",
    name: "Miguel Andrade",
    whatsapp: "573006789012",
    phone: "3019428421",
    wapp: "https://wa.link/0tp3fc",
  },
  "landing-1": {
    slug: "landing-1",
    name: "Alejandro Montenegro",
    whatsapp: "573170634750",
    phone: "3170634750",
    wapp: "https://",
  },
  "landing-2": {
    slug: "landing-2",
    name: "Carolina Villanueva",
    whatsapp: "573002020202",
    phone: "3002020202",
    wapp: "https://w.app/3002020202",
  },
  "landing-3": {
    slug: "landing-3",
    name: "Rodrigo Castellanos",
    whatsapp: "573003030303",
    phone: "3003030303",
    wapp: "https://w.app/3003030303",
  },
  "landing-4": {
    slug: "landing-4",
    name: "Isabella Montero",
    whatsapp: "573004040404",
    phone: "3004040404",
    wapp: "https://w.app/3004040404",
  },
  "landing-5": {
    slug: "landing-5",
    name: "Felipe Andrade",
    whatsapp: "573005050505",
    phone: "3005050505",
    wapp: "https://w.app/3005050505",
  },
  "landing-6": {
    slug: "landing-6",
    name: "Valentina Restrepo",
    whatsapp: "573006060606",
    phone: "3006060606",
    wapp: "https://w.app/3006060606",
  },
  "landing-7": {
    slug: "landing-7",
    name: "Sebastián Ochoa",
    whatsapp: "573007070707",
    phone: "3007070707",
    wapp: "https://w.app/3007070707",
  },
  "landing-8": {
    slug: "landing-8",
    name: "Mariana Cárdenas",
    whatsapp: "573008080808",
    phone: "3008080808",
    wapp: "https://w.app/3008080808",
  },
  roman: {
    slug: "roman",
    name: "Román",
    whatsapp: "573169007620",
    phone: "3169007620",
    wapp: "https://wa.link/i5t337",
  },
};

export const defaultAdvisor: AdvisorData = {
  slug: "home",
  name: "Alianza Andina Empresarial",
  whatsapp: "573170634750",
  phone: "3169007623",
  wapp: "https://wa.me/+573170634750?text=Hola%2C%20estoy%20interesado(a)%20en%20conocer%20el%20proceso%20de%20financiamiento%20de%20Alianza%20Andina%20Empresarial.",
};